import VariacoesLista from "@/pages/produtos/variacoes/VariacoesLista";

export default [
  {
    path: "/catalogo/variacoes",
    name: "VariacoesLista",
    component: VariacoesLista,
    meta: { permissao: "variacoes:acessar" },
  },
];
